import { ServiceCard } from "@/components/common/ServiceCard";
import { motion } from "framer-motion";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const serviceImageMap: Record<string, string> = {
  "field-operations": "/images/services/field-ops.svg",
  "local-distribution": "/images/services/local-distribution.svg",
  "media-documentation": "/images/services/media-documentation.svg",
  "delegate-travel": "/images/services/delegate-travel.svg",
  "reporting": "/images/services/reporting.svg",
  "compliance": "/images/services/compliance.svg",
  "social-media": "/images/services/social-media.svg",
};

export const Services = () => {
  const { t } = useTranslation();

  const services = useMemo(() => {
    const translated = t("services.items", { returnObjects: true }) as any[];
    const items = Array.isArray(translated) ? translated : [];

    return items.map((service) => ({
      ...service,
      features: Array.isArray(service.features) ? service.features : [],
      image: serviceImageMap[service.id] || "/images/services/field-ops.svg",
    }));
  }, [t]);

  return (
    <section id="services" className="py-24 bg-neutral-50">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true, amount: 0.5 }}
          className="text-center md:text-left max-w-3xl mb-14"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-neutral-900">
            {t('services.title')}
          </h2>
          <p className="mt-4 text-lg text-neutral-600">
            {t('services.subtitle')}
          </p>
        </motion.div>
        
        <div className="grid gap-8 md:grid-cols-2 xl:grid-cols-3">
          {services.map((service, index) => (
            <ServiceCard
              key={service.id}
              service={service}
              index={index}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
